'use strict';

import angular from 'angular';

// Hack for textangular and angular > 1.6.9
//angular.lowercase = function(text) { if(text != null) return text.toLowerCase(); }

// import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';
import 'angular-socket-io';

import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import uiSelect from 'ui-select';
// import ngMessages from 'angular-messages';

// 'pascalprecht.translate'
import 'angular-translate';
import 'angular-translate-loader-static-files';
import 'angular-translate-storage-cookie';
//import 'angular-google-chart';
import 'angular-toastr';

// 'ghiscoding.validation'
import 'angular-validation-ghiscoding';

import 'angulartics';
import 'angulartics-google-analytics';

import 'jsonformatter';

import 'oclazyload';

import * as config from './app.config';
import * as filters from './app.filters';
import * as timefilters from './app.timefilters';

import {
	langStorage
} from './app.config';

import _Auth from '../components/auth/auth.module';
import Modal from '../components/modal/modal.service';
import account from './account';

import champs from './frontend/champs';
import events from './frontend/events';
import event from './frontend/event';
import mypanel from './frontend/mypanel';
import results from './frontend/results';

import champs_admin from './backend/champs';
import events_admin from './backend/events';

import navbar from '../components/navbar/navbar.component';
import footer from '../components/footer/footer.component';
import consent from '../components/cookie-consent/consent.component';
import main from './frontend/home/home.component';
import constants from './app.constants';
import util from '../components/util/util.module';
import socket from '../components/socket/socket.service';

import './app.css';

angular.module('everlaps', [ngCookies, ngResource, ngSanitize, 'btford.socket-io', uiRouter, uiBootstrap, "ngAnimate", uiSelect,
	//@{ GUSI
	'pascalprecht.translate', 'ghiscoding.validation', 'toastr',
	'angular-loading-bar', 'angularMoment', 'oc.lazyLoad',
	'angulartics', 'angulartics.google.analytics',
	'jsonFormatter',
	//@}
	_Auth, Modal, account,
	champs, events, event, mypanel, results, champs_admin, events_admin,
	navbar, footer, consent, main, constants, socket, util
])
	.config(config.interceptorConfig)
	.config(config.routeConfig)
	.config(config.translationConfig)
	.config(config.toastConfig)
	.config(function(cfpLoadingBarProvider) {
		'ngInject';
		cfpLoadingBarProvider.includeSpinner = true;
	})
	.factory('langStorage', config.langFactory)
	.factory('messageService', config.messageService)

	.filter('filterLapsTime', timefilters.filterLapsTime)
	.filter('filterFullTime', timefilters.filterFullTime)
	.filter('filterLaptime', timefilters.filterLaptime)
	.filter('filterDiff', timefilters.filterDiff)
	
	.component('everlapsPos', timefilters.everlapsPos)
	.component('everlapsPosForced', timefilters.everlapsPosForced)
	.component('everlapsLapsTime', timefilters.everlapsLapsTime)
	.component('everlapsComparison', timefilters.everlapsComparison)
	.component('everlapsLaptime', timefilters.everlapsLaptime)
	.component('everlapsTopX', timefilters.everlapsTopX)
	//.directive('everlapsValidTransponder', filters.everlapsValidTransponder)
	.component('everlapsPopableAvatar', filters.everlapsPopableAvatar)
	.directive('everlapsInscriptionExtraInfo', filters.everlapsInscriptionExtraInfo)
	.component('everlapsDriverName', filters.everlapsDriverName)
	.component('everlapsDriverNameOptionalNick', filters.everlapsDriverNameOptionalNick)
	.component('everlapsDriverNick', filters.everlapsDriverNick)
	.component('everlapsDriverAnnotations', filters.everlapsDriverAnnotations)
	.component('everlapsCarNumber', filters.everlapsCarNumber)
	.component('everlapsFromToDate', filters.everlapsFromToDate)

	// NOTE: El modulo tiene que ser everlaps, no puede ser everlaps.XXX, porque entonces no es accesible
	.directive('bootstrapValidationDecorator', config.bootstrapValidationDecorator)
	.directive('compile', function($compile) { // https://docs.angularjs.org/api/ng/service/$compile
		'ngInject';
		// directive factory creates a link function
		return function(scope, element, attrs) {
			scope.$watch(function(scope) {
				// watch the 'compile' expression for changes
				return scope.$eval(attrs.compile);
			},
			function(value) {
				// when the 'compile' expression changes assign it into the current DOM
				element.html(value);
				// compile the new DOM and link it to the current scope.
				// NOTE: we only compile .childNodes so that we don't get into infinite loop compiling ourselves
				$compile(element.contents())(scope);
			});
		};
	})
	.run(function ($rootScope, $location, $templateCache, $state, Auth/*, editableOptions*/) {
		'ngInject';
		// Redirect to login if route requires auth and you're not logged in

		$rootScope.$on('$stateChangeStart', function (event, next) {
			Auth.isLoggedIn(function (loggedIn) {
				if (next.authenticate && !loggedIn) {
					$location.path('/login');
				}
			});
		});

		// Save previous state
		$rootScope.$on("$stateChangeSuccess", function(event, to, toParams, from, fromParams) {
			$state.__from = from;
			$state.__fromParams = fromParams;
		});

		$templateCache.put("avatarpopuptemplate.html", require("./common/avatarpopuptemplate.html"));
		$templateCache.put("extrainfopopup.html", require("./common/extrainfopopup.html"));
		$templateCache.put("regionspopuptemplate.html", require("./common/regionspopuptemplate.html"));
		/*$templateCache.put("notavailable.html", require("./common/notavailable.html"));*/

		// angular-xeditable configuration
		//editableOptions.theme = 'bs3';
	});

angular.element(document)
	.ready(() => {
		angular.bootstrap(document, ['everlaps'], {
			strictDi: true
		});
	});



// WEBPACK FOOTER //
// ./client/app/app.js